import React from "react";
//#region components
import { Box, Grid, Skeleton } from "@mui/material";
//#endregion

interface ExpandableListItemSkeletonProps {
  /** Number of collapsed rows to render */
  count?: number;
}

const ExpandableListItemSkeleton: React.FC<ExpandableListItemSkeletonProps> = (props) => {
  const { count = 4 } = props;

  return (
    <Grid container rowGap={1}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid item xs={12} key={index}>
          <Box
            sx={{
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              bgcolor: "background.paper",
              borderRadius: "8px",
              px: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Skeleton variant="circular" width={10} height={10} />
              <Skeleton variant="text" width={180} height={16} />
            </Box>
            <Skeleton variant="text" width={64} height={16} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default ExpandableListItemSkeleton;